import { FETCH_REVENUE_CENTER_ORDERS } from './actionTypes'
import api from 'utils/api'

export const fetchRevenueCenterOrders = id => dispatch =>
  api
    .fetchRevenueCenterOrders(id)
    .then(({ data }) => dispatch(fetchRevenueCenterAction({ data, id })))

export const fetchRevenueCenterAction = data => ({
  type: FETCH_REVENUE_CENTER_ORDERS,
  payload: data,
})
